const PANELS = [
  {
    name: "Full Blood Count - Capillary",
    link: "/account?view=dashboard_fbc",
    iconColor: "#74c5be",
    biomarkersCount: "15",
  },
  {
    name: "Cholesterol Blood Test (Venous)",
    link: "/account?view=odt_panel_cholesterol_blood_test",
    iconColor: "#f5973a",
    biomarkersCount: "6",
  },
  {
    name: "Female Hair Loss Blood Test (Venous)",
    link: "/account?view=odt_panel_female_hair_loss_blood_test",
    iconColor: "#b7978b",
    biomarkersCount: "25",
  },
  {
    name: "Full Blood Count - Venous",
    link: "/account?view=dashboard_fbc",
    iconColor: "#74c5be",
    biomarkersCount: "15",
  },
  {
    name: "Liver Function Blood Test (Capillary)",
    link: "/account?view=odt_panel_liver_function_blood_test",
    iconColor: "#74c5be",
    biomarkersCount: "8",
  },
  {
    name: "Liver Function Blood Test (Venous)",
    link: "/account?view=odt_panel_liver_function_blood_test",
    iconColor: "#74c5be",
    biomarkersCount: "8",
  },
  {
    name: "Essential All Systems Blood Test (Venous)",
    link: "/account?view=odt_panel_essential_all_systems_blood_test",
    iconColor: "#699671",
    biomarkersCount: "40",
  },
  {
    name: "Essential All Systems Blood Test (Capillary)",
    link: "/account?view=odt_panel_essential_all_systems_blood_test",
    iconColor: "#699671",
    biomarkersCount: "40",
  },
  {
    name: "Advanced Kidney Function Blood Test (Venous)",
    link: "/account?view=odt_panel_advanced_kidney_function_blood_test",
    iconColor: "#369bcf",
    biomarkersCount: "8",
  },
  {
    name: "Advanced Kidney Function Blood Test (Capillary)",
    link: "/account?view=odt_panel_advanced_kidney_function_blood_test",
    iconColor: "#369bcf",
    biomarkersCount: "8",
  },
  {
    name: "Kidney Function Blood Test (Venous)",
    link: "/account?view=odt_panel_kidney_function_blood_test",
    iconColor: "#dc3558",
    biomarkersCount: "4",
  },
  {
    name: "Kidney Function Blood Test (Capillary)",
    link: "/account?view=odt_panel_kidney_function_blood_test",
    iconColor: "#dc3558",
    biomarkersCount: "4",
  },
  {
    name: "Aches and Pains Blood Test (Venous)",
    link: "/account?view=odt_panel_aches_and_pains_blood_test",
    iconColor: "#02afea",
    biomarkersCount: "26",
  },
  {
    name: "Aches and Pains Blood Test (Capillary)",
    link: "/account?view=odt_panel_aches_and_pains_blood_test",
    iconColor: "#02afea",
    biomarkersCount: "26",
  },
  {
    name: "Cholesterol Blood Test (Capillary)",
    link: "/account?view=odt_panel_cholesterol_blood_test",
    iconColor: "#f5973a",
    biomarkersCount: "6",
  },
  {
    name: "Advanced Electrolytes Blood Test (Venous)",
    link: "/account?view=odt_panel_advanced_electrolytes_panel_blood_test",
    iconColor: "#393b8e",
    biomarkersCount: "7",
  },
  {
    name: "Advanced Electrolytes Blood Test (Capillary)",
    link: "/account?view=odt_panel_advanced_electrolytes_panel_blood_test",
    iconColor: "#393b8e",
    biomarkersCount: "7",
  },
  {
    name: "Electrolytes Blood Test (Venous)",
    link: "/account?view=odt_panel_electrolytes_panel_blood_test",
    iconColor: "#74ccf4",
    biomarkersCount: "4",
  },
  {
    name: "Electrolytes Blood Test (Capillary)",
    link: "/account?view=odt_panel_electrolytes_panel_blood_test",
    iconColor: "#74ccf4",
    biomarkersCount: "4",
  },
  {
    name: "Advanced Diabetes Blood Test (Venous)",
    link: "/account?view=odt_panel_advanced_diabetes_panel_blood_test",
    iconColor: "#b79990",
    biomarkersCount: "2",
  },
  {
    name: "Advanced Diabetes Blood Test (Capillary)",
    link: "/account?view=odt_panel_advanced_diabetes_panel_blood_test",
    iconColor: "#b79990",
    biomarkersCount: "2",
  },
  {
    name: "Diabetes Blood Test (Venous)",
    link: "/account?view=odt_panel_diabetes_blood_test",
    iconColor: "#a8d8cc",
    biomarkersCount: "1",
  },
  {
    name: "Diabetes Blood Test (Capillary)",
    link: "/account?view=odt_panel_diabetes_blood_test",
    iconColor: "#a8d8cc",
    biomarkersCount: "1",
  },
  {
    name: "Abdominal Symptoms Blood Test (Venous)",
    link: "/account?view=odt_panel_abdominal_pain_blood_test",
    iconColor: "#ba5543",
    biomarkersCount: "30",
  },
  {
    name: "Abdominal Symptoms Blood Test (Capillary)",
    link: "/account?view=odt_panel_abdominal_pain_blood_test",
    iconColor: "#ba5543",
    biomarkersCount: "30",
  },
  {
    name: "Female Hair Loss Blood Test (Capillary)",
    link: "/account?view=odt_panel_female_hair_loss_blood_test",
    iconColor: "#b7978b",
    biomarkersCount: "25",
  },
  {
    name: "Male Hair Loss Blood Test (Venous)",
    link: "/account?view=odt_panel_male_hair_loss_blood_test",
    iconColor: "#699ad0",
    biomarkersCount: "22",
  },
  {
    name: "Male Hair Loss Blood Test (Capillary)",
    link: "/account?view=odt_panel_male_hair_loss_blood_test",
    iconColor: "#699ad0",
    biomarkersCount: "22",
  },
  {
    name: "Tired All The Time Blood Test (Venous)",
    link: "/account?view=odt_panel_tired_all_the_time_blood_test",
    iconColor: "#76c6bf",
    biomarkersCount: "34",
  },
  {
    name: "Tired All The Time Blood Test (Capillary)",
    link: "/account?view=odt_panel_tired_all_the_time_blood_test",
    iconColor: "#76c6bf",
    biomarkersCount: "34",
  },
  {
    name: "Ultimate Performance Blood Test (Venous)",
    link: "/account?view=odt_panel_ultimate_performance_blood_test",
    iconColor: "#e50f16",
    biomarkersCount: "57",
  },
  {
    name: "Ultimate Performance Blood Test (Capillary)",
    link: "/account?view=odt_panel_ultimate_performance_blood_test",
    iconColor: "#e50f16",
    biomarkersCount: "57",
  },
  {
    name: "Ultimate Healthy Woman Blood Test (Venous)",
    link: "/account?view=odt_panel_ultimate_healthy_woman_blood_test",
    iconColor: "#e50f16",
    biomarkersCount: "47",
  },
  {
    name: "Ultimate Healthy Woman Blood Test (Capillary)",
    link: "/account?view=odt_panel_ultimate_healthy_woman_blood_test",
    iconColor: "#e50f16",
    biomarkersCount: "47",
  },
  {
    name: "Ultimate Healthy Man Blood Test (Venous)",
    link: "/account?view=odt_panel_ultimate_healthy_man_blood_test",
    iconColor: "#333367",
    biomarkersCount: "45",
  },
  {
    name: "Ultimate Healthy Man Blood Test (Capillary)",
    link: "/account?view=odt_panel_ultimate_healthy_man_blood_test",
    iconColor: "#333367",
    biomarkersCount: "45",
  },
  {
    name: "Female Fertility Insights Blood Test (Venous)",
    link: "/account?view=odt_panel_female_fertility_insights_blood_test",
    iconColor: "#333367",
    biomarkersCount: "9",
  },
  {
    name: "Female Fertility Insights Blood Test (Capillary)",
    link: "/account?view=odt_panel_female_fertility_insights_blood_test",
    iconColor: "#333367",
    biomarkersCount: "9",
  },
  {
    name: "Ultimate Female Fertility Blood Test (Venous)",
    link: "/account?view=odt_panel_ultimate_female_fertility_blood_test",
    iconColor: "#333367",
    biomarkersCount: "50",
  },
  {
    name: "Ultimate Longevity Blood Test (Venous)",
    link: "/account?view=odt_panel_ultimate_longevity_blood_test",
    iconColor: "#333367",
    biomarkersCount: "66",
  },
];

const GENDER = {
  male: "male",
  female: "female",
};

function tabs(
  tabContentSelector,
  tabParentSelector,
  tabHeaderItemSelector,
  tabHeaderItemActiveSelector,
) {
  const tabcontent = document.querySelectorAll(tabContentSelector),
    tabParent = document.querySelector(tabParentSelector),
    tabheaderItem = document.querySelectorAll(
      `${tabParentSelector} > ${tabHeaderItemSelector}`,
    );

  function hideTabsContent() {
    tabcontent.forEach((item) => {
      item.classList.remove("is-shown");
      item.classList.add("is-hidden");
    });

    tabheaderItem.forEach((item) => {
      item.classList.remove(tabHeaderItemActiveSelector);
      item.setAttribute("aria-selected", "false");
    });
  }

  function showTabContent(i = 0) {
    tabcontent[i].classList.remove("is-hidden");
    tabcontent[i].classList.add("is-shown");
    tabheaderItem[i].classList.add(tabHeaderItemActiveSelector);
    tabheaderItem[i].setAttribute("aria-selected", "true");
  }

  hideTabsContent();
  showTabContent();

  tabParent.addEventListener("click", (event) => {
    const target = event.target;

    if (target && target.classList.contains(tabHeaderItemSelector.slice(1))) {
      tabheaderItem.forEach((item, i) => {
        if (target == item) {
          hideTabsContent();
          showTabContent(i);
        }
      });
    }
  });
}

function toggleBiomarkersView(tableSelector, graphSelector, buttonSelector) {
  const biochemistryTable = document.querySelectorAll(tableSelector),
    biochemistryGraph = document.querySelectorAll(graphSelector),
    buttonTableView = document.querySelector(`${buttonSelector} .table-view`),
    buttonGraphView = document.querySelector(`${buttonSelector} .graph-view`),
    button = document.querySelector(buttonSelector);
  let dataView = button.getAttribute("data-view");

  function showGraph() {
    biochemistryGraph.forEach((item) => {
      item.classList.remove("is-hidden");
      item.classList.add("is-shown");
    });
    biochemistryTable.forEach((item) => {
      item.classList.remove("is-shown");
      item.classList.add("is-hidden");
    });

    buttonGraphView.classList.remove("is-shown");
    buttonGraphView.classList.add("is-hidden");
    buttonTableView.classList.remove("is-hidden");
    buttonTableView.classList.add("is-shown");
  }

  function showTable() {
    biochemistryGraph.forEach((item) => {
      item.classList.remove("is-shown");
      item.classList.add("is-hidden");
    });
    biochemistryTable.forEach((item) => {
      item.classList.remove("is-hidden");
      item.classList.add("is-shown");
    });

    buttonTableView.classList.remove("is-shown");
    buttonTableView.classList.add("is-hidden");
    buttonGraphView.classList.remove("is-hidden");
    buttonGraphView.classList.add("is-shown");
  }

  if (dataView == "graph") {
    showGraph();
    button.setAttribute("data-view", "table");
  } else {
    showTable();
    button.setAttribute("data-view", "graph");
  }
}

function toggleBiomarkerDescriptionView(descriptionTabs, buttonSelector) {
  const biomarkerDescriptionTabs = document.querySelectorAll(descriptionTabs),
    buttonDescriptionShow = document.querySelector(
      `${buttonSelector} .description-on`,
    ),
    buttonDescriptionHide = document.querySelector(
      `${buttonSelector} .description-off`,
    ),
    button = document.querySelector(buttonSelector);

  let dataView = button.getAttribute("data-view");

  function showBiomarkerDescriptionTabs() {
    biomarkerDescriptionTabs.forEach((item) => {
      item.classList.remove("is-hidden");
      item.classList.add("is-shown");
    });

    buttonDescriptionHide.classList.remove("is-shown");
    buttonDescriptionHide.classList.add("is-hidden");
    buttonDescriptionShow.classList.add("is-shown");
    buttonDescriptionShow.classList.remove("is-hidden");
  }

  function hideBiomarkerDescriptionTabs() {
    biomarkerDescriptionTabs.forEach((item) => {
      item.classList.remove("is-shown");
      item.classList.add("is-hidden");
    });

    buttonDescriptionShow.classList.remove("is-shown");
    buttonDescriptionShow.classList.add("is-hidden");
    buttonDescriptionHide.classList.add("is-shown");
    buttonDescriptionHide.classList.remove("is-hidden");
  }

  if (dataView == "on") {
    showBiomarkerDescriptionTabs();
    button.setAttribute("data-view", "off");
  } else {
    hideBiomarkerDescriptionTabs();
    button.setAttribute("data-view", "on");
  }
}

function generateString(maxLength) {
  const characters = "abcdefghijklmnopqrstuvwxyz";
  const stringLength = Math.floor(
    Math.random() * (Math.floor(maxLength) - 10) + 10,
  );
  let result = "";

  for (let i = 0; i < stringLength; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }

  return result;
}

function getResultDate(string) {
  const result_date = new Date(string);
  return (
    result_date.getDate() +
    "-" +
    (result_date.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    result_date.getFullYear().toString().substr(-2)
  );
}

function isEmpty(obj) {
  for (const prop in obj) {
    if (Object.hasOwn(obj, prop)) {
      return false;
    }
  }

  return true;
}

function getBiomarkerResultTableTemplate(
  title,
  unit,
  tableRowsTpl,
  popupTpl,
  showMoreTpl,
  infoButtonTpl,
  warningTpl,
) {
  return `
    <div class="biomarker-table-block">
      ${infoButtonTpl}
      <div class="biomarker-table-inner">
        <div class="biomarker-table-header">
          ${title} ${warningTpl}
        </div>
        <div class="biomarker-table-body">
          <table class="biomarker-table">
            <thead>
              <tr>
                <th>Date</th>
                <th><div>Result</div><div class="result-units">${unit}</div></th>
                <th><div>Normal</div><div class="result-units">${unit}</div></th>
              </tr>
            </thead>
            <tbody>
              ${tableRowsTpl}
            </tbody>
          </table>
        </div>
      </div>
      ${showMoreTpl}
      <span><i class="fa-solid fa-person-half-dress"></i> - General range.</span>
      <span><i class="fa-solid fa-person-dress" style="color: #e91e63"></i> - Female range.</span>
      <span><i class="fa-solid fa-person" style="color: #00AEEC"></i> - Male range.</span>
      <div>
        <i>
          <small>Shown reference ranges are general guidelines only. Ranges change over time and are not specific to you.
            Use laboratory PDF ranges in case of differences with your dashboard. Please consult your doctor for further interpretation, specific to you.
          </small>
        </i>
      </div>
    </div>
    ${popupTpl}
  `;
}

function oldRenderBiomarkerResultTable(
  meta,
  chartData,
  biomarkerInfo,
  hasWarning,
  gender,
) {
  const arrayFromTitle = chartData.title.split(" "),
    unit = arrayFromTitle[arrayFromTitle.length - 1],
    hash = generateString(6);

  let tableRowsTpl = "",
    tableRowsCount = 0,
    warningTpl = "",
    popupTpl = "",
    showMoreTpl = "",
    genderResultRengeTpl = "";

  console.log("wag1");

  if (meta.ref_1_low_value) {
    switch (gender) {
      case GENDER.male:
        genderResultRengeTpl += `<div><i class="fa-solid fa-person" style="color: #00AEEC"></i> ${meta.ref_1_low_value} - ${meta.ref_1_high_value}</div>`;
        break;

      case GENDER.female:
        genderResultRengeTpl += `<div><i class="fa-solid fa-person-dress" style="color: #e91e63"></i> ${meta.ref_2_low_value} - ${meta.ref_2_high_value}</div>`;
        break;

      default:
        genderResultRengeTpl += `
            <div><i class="fa-solid fa-person-half-dress"></i> ${meta.ref_overall_min_value} - ${meta.ref_overall_max_value}</div>
            <div><i class="fa-solid fa-person-dress" style="color: #e91e63"></i> ${meta.ref_2_low_value} - ${meta.ref_2_high_value}</div>
            <div><i class="fa-solid fa-person" style="color: #00AEEC"></i> ${meta.ref_1_low_value} - ${meta.ref_1_high_value}</div>
          `;
        break;
    }
  } else {
    genderResultRengeTpl += `<div><i class="fa-solid fa-person-half-dress"></i> ${meta.ref_overall_min_value} - ${meta.ref_overall_max_value}</div>`;
  }

  chartData.series[0].data.reverse().forEach((item, i) => {
    date = getResultDate(item.x);
    tableRowsCount = i + 1;
    let visibility = i > 1 ? "is-hidden" : "is-shown";

    tableRowsTpl += `<tr class="${visibility}">
      <td>${date}</td>
      <td>${item.value}</td>
      <td>
        <div class="table-column-normal">
          ${genderResultRengeTpl}
        </div>
      </td>
    </tr>`;
  });

  if (!isEmpty(biomarkerInfo)) {
    infoButtonTpl = `
      <button class="icon-button color-text-300 info-button" data-template="${hash}">
        <i class="fa-solid fa-circle-info"></i>
      </button>
    `;

    popupTpl = `
      <div style="display: none;">
        <div id="${hash}">
          <div class="popup-subtitle">Description</div>
            ${biomarkerInfo.description}
          <div class="popup-subtitle">Low result</div>
            ${biomarkerInfo.low}
          <div class="popup-subtitle">High result</div>
            ${biomarkerInfo.high}
        </div>
      </div>
    `;
  } else {
    (infoButtonTpl = ""), (popupTpl = "");
  }

  if (tableRowsCount > 2) {
    showMoreTpl = `
      <div class="show-more-panel">
        <button class="icon-button color-text-300 show-more-button">
          <div class="show-more-view is-shown">
            Show more (${tableRowsCount - 2})
            <i class="fa-solid fa-chevron-down"></i>
          </div>
          <div class="show-less-view is-hidden">
            Show less
            <i class="fa-solid fa-chevron-up"></i>
          </div>
        </button>
      </div>
    `;
  }

  if (hasWarning) {
    warningTpl =
      '<i class="fa-solid fa-circle warning-badge"></i><span style="color:#f5973a"> - Needs attention</span>';
  }

  return getBiomarkerResultTableTemplate(
    meta.biomarker_title,
    unit,
    tableRowsTpl,
    popupTpl,
    showMoreTpl,
    infoButtonTpl,
    warningTpl,
  );
}

function render_table_card(
  id,
  title,
  unit,
  test_result_list,
  description,
  low_description,
  high_description,
  has_warning,
) {
  let tableRowsTpl = "";
  let warningTpl = "";
  let showMoreTpl = "";

  let tableRowsCount = 0;
  // Parse DD-MM-YYYY format to Date object
  const parseDate = (dateStr) => {
    const [day, month, year] = dateStr.split("-");
    return new Date(year, month - 1, day);
  };
  // Create a copy and sort by date descending (most recent first)
  [...test_result_list]
    .sort((a, b) => {
      return parseDate(b.timestamp) - parseDate(a.timestamp);
    })
    .forEach((item, i) => {
      tableRowsCount = i + 1;
      const visibility = i > 1 ? "is-hidden" : "is-shown";

      // Format reference range based on available values
      let refRange;
      const hasLower = item.lower_limit != null && item.lower_limit !== "null";
      const hasUpper = item.upper_limit != null && item.upper_limit !== "null";
      if (hasLower && hasUpper) {
        refRange = `${item.lower_limit} - ${item.upper_limit}`;
      } else if (hasLower) {
        refRange = `> ${item.lower_limit}`;
      } else if (hasUpper) {
        refRange = `< ${item.upper_limit}`;
      } else {
        refRange = "None";
      }

      tableRowsTpl += `
      <tr class="${visibility}">
        <td>${item.timestamp}</td>
        <td>${item.value_text}</td>
        <td>
          <div class="table-column-normal">
            <div><i class="fa-solid fa-person-half-dress"></i> ${refRange}</div>
          </div>
        </td>
      </tr>`;
    });

  if (tableRowsCount > 2) {
    showMoreTpl = `
      <div class="show-more-panel">
        <button class="icon-button color-text-300 show-more-button">
          <div class="show-more-view is-shown">
            Show more (${tableRowsCount - 2})
            <i class="fa-solid fa-chevron-down"></i>
          </div>
          <div class="show-less-view is-hidden">
            Show less
            <i class="fa-solid fa-chevron-up"></i>
          </div>
        </button>
      </div>
    `;
  }

  if (has_warning) {
    warningTpl =
      '<i class="fa-solid fa-circle warning-badge"></i><span style="color:#f5973a"> - Needs attention</span>';
  }

  return `
    <div class="biomarker-card">
      <div class="biomarker-table-inner">
        <div class="biomarker-table-header">
          ${title} ${warningTpl}
        </div>
        <div class="biomarker-table-body">
          <table class="biomarker-table">
            <thead>
              <tr>
                <th>Date</th>
                <th><div>Result</div><div class="result-units">${unit}</div></th>
                <th><div>Normal</div><div class="result-units">${unit}</div></th>
              </tr>
            </thead>
            <tbody>
              ${tableRowsTpl}
            </tbody>
          </table>
        </div>
      </div>
      ${showMoreTpl}
      <span><i class="fa-solid fa-person-half-dress"></i> - General range.</span>
      <span><i class="fa-solid fa-person-dress" style="color: #e91e63"></i> - Female range.</span>
      <span><i class="fa-solid fa-person" style="color: #00AEEC"></i> - Male range.</span>
      <div>
        <i>
          <small>Shown reference ranges are general guidelines only. Ranges change over time and are not specific to you.
            Use laboratory PDF ranges in case of differences with your dashboard. Please consult your doctor for further interpretation, specific to you.
          </small>
        </i>
      </div>
      ${(() => {
        const hasDesc = description && description !== "null";
        const hasLow = low_description && low_description !== "null";
        const hasHigh = high_description && high_description !== "null";
        if (!hasDesc && !hasLow && !hasHigh) return "";
        const tabs = [];
        const contents = [];
        let firstTab = true;
        if (hasDesc) {
          tabs.push(
            `<div class="tab-item${firstTab ? "" : " ml-auto"}" role="tab" id="description-table-${id}-tab" aria-controls="description-table-${id}" aria-selected="${firstTab}">Description</div>`,
          );
          contents.push(
            `<div class="tab-content" id="description-table-${id}" role="tabpanel" aria-labelledby="description-table-${id}-tab">${description}</div>`,
          );
          firstTab = false;
        }
        if (hasLow) {
          tabs.push(
            `<div class="tab-item${firstTab ? "" : " ml-auto"}" role="tab" id="low-result-table-${id}-tab" aria-controls="low-result-table-${id}" aria-selected="${firstTab}">Low result</div>`,
          );
          contents.push(
            `<div class="tab-content" id="low-result-table-${id}" role="tabpanel" aria-labelledby="low-result-table-${id}-tab">${low_description}</div>`,
          );
          firstTab = false;
        }
        if (hasHigh) {
          tabs.push(
            `<div class="tab-item${!hasLow && !firstTab ? " ml-auto" : ""}" role="tab" id="high-result-table-${id}-tab" aria-controls="high-result-table-${id}" aria-selected="${firstTab}">High result</div>`,
          );
          contents.push(
            `<div class="tab-content" id="high-result-table-${id}" role="tabpanel" aria-labelledby="high-result-table-${id}-tab">${high_description}</div>`,
          );
        }
        return `
      <div class="biomarker-description-tabs">
        <div class="odt-tabs" id="biomarkerTable${id}Tabs" role="tablist">
          ${tabs.join("\n          ")}
        </div>
        <div class="tab-container" id="biomarkerTable${id}Container">
          ${contents.join("\n          ")}
        </div>
      </div>`;
      })()}
    </div>
  `;
}

function toggleShowMoreButton() {
  const showMoreButtonArray = document.querySelectorAll(".show-more-button");

  showMoreButtonArray.forEach((item) => {
    const showMoreView = item.querySelector(".show-more-view");
    const showLessView = item.querySelector(".show-less-view");
    let biomarkerTableInner = item.parentElement.previousElementSibling;
    const tableRows = biomarkerTableInner.querySelectorAll("tbody tr");
    let isShown = false;

    item.addEventListener("click", (e) => {
      e.preventDefault();

      if (!isShown) {
        tableRows.forEach((row) => {
          row.classList.remove("is-hidden");
          row.classList.add("is-shown");
        });

        showMoreView.classList.remove("is-shown");
        showMoreView.classList.add("is-hidden");
        showLessView.classList.remove("is-hidden");
        showLessView.classList.add("is-shown");

        isShown = true;
      } else {
        tableRows.forEach((row, i) => {
          if (i > 1) {
            row.classList.remove("is-shown");
            row.classList.add("is-hidden");
          }
        });

        showMoreView.classList.add("is-shown");
        showMoreView.classList.remove("is-hidden");
        showLessView.classList.add("is-hidden");
        showLessView.classList.remove("is-shown");

        isShown = false;
      }
    });
  });
}

function toggleTestListVisibility(button) {
  const testList = document.getElementById("testList");
  let dataView = testList.getAttribute("data-view");

  function showPanel() {
    testList.classList.remove("is-hidden");
    testList.classList.add("is-shown");
    testList.setAttribute("data-view", "off");
  }

  function hidePanel() {
    testList.classList.remove("is-shown");
    testList.classList.add("is-hidden");
    testList.setAttribute("data-view", "on");
  }

  dataView == "on" ? showPanel() : hidePanel();
}

function getTestPanelTemplate({ name, link, iconColor, biomarkersCount }) {
  return `
    <div class="panels-grid-item">
      <div class="o-media">
        <div class="o-media-body">
          <h5 class="o-media-title font-weight-600">${name}</h5>
          <div class="o-media-message">
            <a href="${link}" class="odt-button">View Results</a>
          </div>
        </div>
        <div class="o-media-image biomarker-icon" style="--biomarker-color: ${iconColor}">
          <div class="biomarkers-count">${biomarkersCount}</div>
          <svg width="51" height="72" viewBox="0 0 51 72" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1260_13625)">
              <path d="M28.9058 0.0451692C28.8343 -0.0176606 28.7314 -0.0176606 28.66 0.0451692C28.0197 0.599213 25.0957 2.8211 25.0957 5.04584C25.0957 7.07924 26.7478 8.72995 28.7829 8.72995C30.8179 8.72995 32.5443 7.07924 32.47 5.04584C32.37 2.27562 29.5489 0.599213 28.9058 0.0451692ZM28.6485 7.97885C28.4827 7.97885 28.3198 7.96457 28.1626 7.93887C29.9262 7.70183 31.2867 6.19106 31.2867 4.36328C31.2867 4.02343 31.241 3.69786 31.1524 3.38657C31.4553 3.84922 31.6297 4.40327 31.6297 5.00015C31.6297 6.64229 30.2949 7.97885 28.6485 7.97885Z" fill="var(--biomarker-color)"/>
              <path d="M22.9622 8.43076C22.9079 8.38506 22.8307 8.38506 22.7764 8.43076C22.2991 8.84486 20.1211 10.5013 20.1211 12.1577C20.1211 13.6742 21.3501 14.9051 22.8679 14.9051C24.3856 14.9051 25.6718 13.6742 25.6175 12.1577C25.5404 10.0929 23.4395 8.84486 22.9622 8.43076ZM22.7678 14.3453C22.6449 14.3453 22.522 14.3339 22.4048 14.3168C23.7196 14.1397 24.7343 13.0116 24.7343 11.6494C24.7343 11.398 24.7 11.1524 24.6343 10.9211C24.8601 11.2667 24.9887 11.6808 24.9887 12.1234C24.9887 13.3486 23.9969 14.3453 22.7678 14.3453Z" fill="var(--biomarker-color)"/>
              <path d="M29.462 13.9859C29.4191 13.9487 29.3591 13.9487 29.3162 13.9859C28.9418 14.3086 27.2383 15.6051 27.2383 16.9017C27.2383 18.0898 28.2015 19.0522 29.3877 19.0522C30.5739 19.0522 31.5828 18.0869 31.54 16.9017C31.4799 15.2853 29.8336 14.3086 29.462 13.9859ZM29.3105 18.6124C29.2133 18.6124 29.119 18.6038 29.0276 18.5896C30.0565 18.4525 30.8483 17.57 30.8483 16.5048C30.8483 16.3077 30.8225 16.1164 30.7711 15.9336C30.9483 16.2049 31.0483 16.5276 31.0483 16.876C31.0483 17.8356 30.2709 18.6124 29.3105 18.6124Z" fill="var(--biomarker-color)"/>
              <path d="M25.5014 71.9991C11.4388 71.9991 0 60.5698 0 46.5188C0 40.4643 2.16085 34.5954 6.0881 29.9945L6.15384 29.9231C6.31962 29.7518 10.2097 25.725 12.1019 23.9286C13.7825 22.335 14.6686 20.056 14.6686 17.3429V12.9448H11.5788C10.7099 12.9448 10.0068 12.2423 10.0068 11.3741C10.0068 10.5059 10.7099 9.80336 11.5788 9.80336H17.8127V17.3429C17.8127 20.9385 16.5865 24.0057 14.2656 26.2076C12.5135 27.8698 8.84061 31.6624 8.44903 32.0708C5.02768 36.0976 3.14409 41.2268 3.14409 46.5188C3.14409 58.8362 13.1737 68.8576 25.5014 68.8576C37.8291 68.8576 47.8588 58.8362 47.8588 46.5188C47.8588 41.2325 45.978 36.1119 42.5653 32.0851C42.0679 31.5967 38.3693 27.9497 36.6401 26.102C34.2963 23.5945 33.1559 20.71 33.1559 17.2772V9.75195H39.2754C40.1443 9.75195 40.8474 10.4545 40.8474 11.3227C40.8474 12.1909 40.1443 12.8934 39.2754 12.8934H36.2999V17.2772C36.2999 19.9104 37.1374 22.0323 38.9381 23.9572C40.7102 25.8506 44.7833 29.8546 44.8233 29.8946L44.9176 29.9945C48.8449 34.5954 51.0057 40.4643 51.0057 46.5188C51.0057 60.5669 39.5669 71.9991 25.5043 71.9991H25.5014Z" fill="var(--biomarker-color)"/>
              <path d="M44.511 46.3997C44.511 56.8894 36.0019 65.3914 25.5035 65.3914C15.0051 65.3914 6.49609 56.8894 6.49609 46.3997C6.49609 33.5167 25.5035 19.9912 25.5035 19.9912C25.5035 19.9912 44.511 33.8337 44.511 46.3997Z" fill="var(--biomarker-color)"/>
            </g>
            <defs>
              <clipPath id="clip0_1260_13625">
                <rect width="51" height="72" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
    </div>
  `;
}

function renderTestPanels(orderList, elementId) {
  const element = document.getElementById(elementId);
  let panelTpl = "";

  orderList.forEach((item) => {
    let panel = PANELS.find((p) => p.name == item);

    if (!isEmpty(panel)) {
      panelTpl += getTestPanelTemplate(panel);
    }
  });

  element.innerHTML += panelTpl;
}

function activatePanelsPageTabs(tabsWrapperSelector) {
  const tabsWrapperList = document.querySelectorAll(tabsWrapperSelector);

  tabsWrapperList.forEach((tabsWrapper) => {
    let tabsC = tabsWrapper.querySelector(".odt-tabs");
    let hash = generateString(4);
    let tabItems = tabsC.querySelectorAll(".tab-item");
    let tabContentItems = tabsWrapper.querySelectorAll(
      ".panel-page-tab-content",
    );

    tabsWrapper.setAttribute("id", `tabs-wrapper-${hash}`);
    tabsC.setAttribute("id", `tabs-${hash}`);

    tabItems[0].setAttribute("id", `biomarkers-${hash}`);
    tabContentItems[0].setAttribute("aria-labelledby", `biomarkers-${hash}`);
    tabItems[0].setAttribute("aria-controls", `biomarkers-content-${hash}`);
    tabContentItems[0].setAttribute("id", `biomarkers-content-${hash}`);
    tabItems[1].setAttribute("id", `comments-${hash}`);
    tabContentItems[1].setAttribute("aria-labelledby", `comments-${hash}`);
    tabItems[1].setAttribute("aria-controls", `comments-content-${hash}`);
    tabContentItems[1].setAttribute("id", `comments-content-${hash}`);
    tabItems[2].setAttribute("id", `recomendations-${hash}`);
    tabContentItems[2].setAttribute(
      "aria-labelledby",
      `recomendations-${hash}`,
    );
    tabItems[2].setAttribute("aria-controls", `recomendations-content-${hash}`);
    tabContentItems[2].setAttribute("id", `recomendations-content-${hash}`);

    tabs(
      `#tabs-wrapper-${hash} .panel-page-tab-content`,
      `#tabs-${hash}`,
      ".tab-item",
      "is-active",
    );
  });
}

function activatePanelsPageToggleBiomarkersView(wrapperSelector) {
  const biomarkersWrapperList = document.querySelectorAll(wrapperSelector);

  biomarkersWrapperList.forEach((biomarkersWrapper) => {
    let hash = generateString(4);
    let button = biomarkersWrapper.querySelector(".toggle-data-view");

    button.setAttribute("id", `toggleDataView-${hash}`);
    biomarkersWrapper.setAttribute("id", `biomarkers-wrapper-${hash}`);

    toggleBiomarkersView(
      `#biomarkers-wrapper-${hash} .biomarkers-table-grid`,
      `#biomarkers-wrapper-${hash} .panel-page-biomarkers-grid`,
      `#toggleDataView-${hash}`,
    );
    button.onclick = () =>
      toggleBiomarkersView(
        `#biomarkers-wrapper-${hash} .biomarkers-table-grid`,
        `#biomarkers-wrapper-${hash} .panel-page-biomarkers-grid`,
        `#toggleDataView-${hash}`,
      );
  });
}

function activatePanelsPageToggleBiomarkerDescriptionView(wrapperSelector) {
  const biomarkersWrapperList = document.querySelectorAll(wrapperSelector);

  biomarkersWrapperList.forEach((biomarkersWrapper) => {
    let biomarkersWrapperId = biomarkersWrapper.getAttribute("id");
    let button = document.querySelector(
      `#${biomarkersWrapperId} .toggle-description-view`,
    );

    toggleBiomarkerDescriptionView(
      `#${biomarkersWrapperId} .biomarker-description-tabs`,
      `#${biomarkersWrapperId} .toggle-description-view`,
    );
    button.onclick = () =>
      toggleBiomarkerDescriptionView(
        `#${biomarkersWrapperId} .biomarker-description-tabs`,
        `#${biomarkersWrapperId} .toggle-description-view`,
      );
  });
}

function onclickScrollToElement(selector) {
  const elementList = document.querySelectorAll(selector);

  elementList.forEach((element) => {
    element.addEventListener("click", (e) => {
      e.preventDefault();
      let targetElement = document.querySelector(element.getAttribute("href"));

      window.scrollTo({
        top: targetElement.offsetTop,
        left: 0,
        behavior: "smooth",
      });
    });
  });
}

function printArea() {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  if (isSafari) {
    document.execCommand("print", false, null);
  } else {
    window.print();
  }
}

function initClinicMap() {
  const map = new google.maps.Map(document.getElementById("map"), {
    zoom: 10,
    center: { lat: 51.5074, lng: -0.1278 }, // Default to London
  });
  window.map = map;

  //var originLocation;
  //autocomplete.addListener('place_changed', async () => {
  //    const place = autocomplete.getPlace();

  //    if (!place.geometry) {
  // User entered the name of a Place that was not suggested and
  // pressed the Enter key, or the Place Details request failed.
  window.alert("No address available for input: '" + place.name + "'");
  return;
  //    }

  // Recenter the map to the selected address
  //    originLocation = place.geometry.location;
  //}
}

function calculateDistance(
  no_button = 0,
  show_more_link = 1,
  number_of_clinics_to_show = 3,
) {
  const postcodeElement = document.getElementById("postcode1");
  const postcode1 = postcodeElement.value.trim();

  if (postcode1 === "") {
    const resultParagraph = document.createElement("p");
    const resultsDiv = document.getElementById("results");
    resultsDiv.innerHTML = "";
    resultParagraph.innerHTML =
      "<small>Please enter your postcode or location.</small>";
    resultsDiv.appendChild(resultParagraph);
    return;
  }

  const options = {
    types: ["address"],
    componentRestrictions: { country: "gb" },
  };

  //const autocomplete = new google.maps.places.Autocomplete(postcodeElement, options);
  //autocomplete.setFields(['address_components', 'geometry', 'name']);

  const originLocation = postcode1;

  const service = new google.maps.DistanceMatrixService();

  service.getDistanceMatrix(
    {
      origins: [originLocation],
      destinations: [
        "One Day Tests, EC2M 4TP",
        "One Day Tests, CR0 1SL",
        "One Day Tests, BN3 3AA",
        "One Day Tests, TN1 1NU",
        "One Day Tests, RH11 9YZ",
        "One Day Tests, GU1 3UQ",
        "One Day Tests, E14 9YX",
        "One Day Tests, SW1P 2QA",
        "One Day Tests, CB2 1NS",
        "One Day Tests, ME14 1HG",
        "One Day Tests, EX4 3SR",
        "One Day Tests, W4 4JE",
        "One Day Tests, L1 9AR",
        "One Day Tests, PL1 1QJ",
        "One Day Tests, BS8 4HR",
        "One Day Tests, GL50 4DT",
        "One Day Tests, OX2 6HA",
        "One Day Tests, B16 8LU",
        "Fortuna House, MK9 2PQ",
        "87 Bridge Street, M3 2RE",
        "28 Park Square West, LS1 2PQ",
        "128 Newport Road, CF24 1DH",
        "One Day Tests, CM1 1EH",
      ],
      travelMode: "DRIVING",
      unitSystem: google.maps.UnitSystem.IMPERIAL,
    },
    (response, status) => {
      if (status !== "OK") {
        console.log("Error was: " + status);
      } else {
        const distances = [];
        const resultsDiv = document.getElementById("results");
        resultsDiv.innerHTML = "";

        for (let i = 0; i < response.rows[0].elements.length; i++) {
          try {
            const distance = response.rows[0].elements[i].distance.value;
            const destination = response.destinationAddresses[i];
            const url = generateDestinationURL(destination);
            const title = generateDestinationTitle(destination);
            distances.push({ title, destination, distance, url });
            console.log("distance:", distance);
            console.log("dest:", destination);
            console.log("url:", url);
            console.log("titlle:", title);
          } catch (err) {
            const resultParagraph = document.createElement("p");
            resultParagraph.innerHTML = "<small>No location found</small>";
            resultsDiv.appendChild(resultParagraph);
            break;
          }
        }

        distances.sort((a, b) => a.distance - b.distance);
        const topChoices = distances.slice(0, number_of_clinics_to_show);

        topChoices.forEach(({ title, destination, distance, url }) => {
          const duration = response.rows[0].elements.find(
            (element) => element.distance.value === distance,
          ).duration.text;

          const resultParagraph = document.createElement("p");
          resultParagraph.innerHTML = generateLocationHtml(
            url,
            title,
            distance,
            duration,
            destination,
            no_button,
          );
          resultsDiv.appendChild(resultParagraph);
        });

        if (distances.length > number_of_clinics_to_show && show_more_link) {
          const smallTag = document.createElement("small");
          const moreLink = document.createElement("a");
          moreLink.textContent = "Show more clinics";
          moreLink.href = "#";
          moreLink.onclick = function () {
            const hiddenResults = distances.slice(3); // Exclude top three distances
            const hiddenResultsDiv = document.createElement("div");
            hiddenResultsDiv.classList.add("hidden");
            hiddenResults.forEach(({ title, destination, distance, url }) => {
              const duration = response.rows[0].elements.find(
                (element) => element.distance.value === distance,
              ).duration.text;

              const resultParagraph = document.createElement("p");
              resultParagraph.innerHTML = generateLocationHtml(
                url,
                title,
                distance,
                duration,
                destination,
                no_button,
              );
              hiddenResultsDiv.appendChild(resultParagraph);
            });
            resultsDiv.appendChild(hiddenResultsDiv);
            this.style.display = "none"; // Hide the "More" link
            return false; // Prevent default link behavior
          };
          smallTag.appendChild(moreLink);
          resultsDiv.appendChild(smallTag);
        }

        const bounds = new google.maps.LatLngBounds();
        bounds.extend(response.originAddresses[0]);
        for (let i = 0; i < response.destinationAddresses.length; i++) {
          bounds.extend(response.destinationAddresses[i]);
        }
        window.map.fitBounds(bounds);
      }
    },
  );
}

function generateDestinationURL(destination) {
  if (destination.includes("EC2M 4TP")) {
    return "/products/book-your-blood-test-london-city";
  }
  if (destination.includes("CR0 1SL")) {
    return "/products/book-your-blood-test-croydon";
  }
  if (destination.includes("BN3 3AA")) {
    return "/products/book-your-blood-test-hove";
  }
  if (destination.includes("TN1 1NU")) {
    return "/products/book-your-blood-test-tunbridge-wells";
  }
  if (destination.includes("RH11 9AQ")) {
    return "/products/book-your-blood-test-crawley";
  }
  if (destination.includes("GU1 3UQ")) {
    return "/products/book-your-blood-test-guildford";
  }
  if (destination.includes("E14 9YX")) {
    return "/products/book-your-blood-test-canary-wharf";
  }
  if (destination.includes("SW1P 2QA")) {
    return "/products/book-your-blood-test-london-victoria";
  }
  if (destination.includes("CB2 1NS")) {
    return "/products/book-your-blood-test-cambridge";
  }
  if (destination.includes("ME14 1HG")) {
    return "/products/book-your-blood-test-maidstone";
  }
  if (destination.includes("EX4 3SR")) {
    return "/products/book-your-blood-test-exeter";
  }
  if (destination.includes("PL1 1QJ")) {
    return "/products/book-your-blood-test-plymouth";
  }
  if (destination.includes("W4 4JE")) {
    return "/products/book-your-blood-test-chiswick";
  }
  if (destination.includes("L1 9AR")) {
    return "/products/book-your-blood-test-liverpool";
  }
  if (destination.includes("CM1 1EH")) {
    return "/products/book-your-blood-test-chelmsford";
  }
  if (destination.includes("BS8 4HR")) {
    return "/products/book-your-blood-test-bristol";
  }
  if (destination.includes("GL50 4DT")) {
    return "/products/book-your-blood-test-cheltenham";
  }
  if (destination.includes("B16 8LU")) {
    return "/products/book-your-blood-test-birmingham";
  }
  if (destination.includes("OX2 6HA")) {
    return "/products/book-your-blood-test-oxford";
  }
  if (destination.includes("MK9 2PQ")) {
    return "/products/book-your-blood-test-milton-keynes";
  }
  if (destination.includes("M3 2RE")) {
    return "/products/book-your-blood-test-manchester";
  }
  if (destination.includes("LS1 2PQ")) {
    return "/products/book-your-blood-test-leeds";
  }
  if (destination.includes("CF24 1DH")) {
    return "/products/book-your-blood-test-cardiff";
  }
  if (destination.includes("EH1 3QH")) {
    return "/products/book-your-blood-test-edinburgh";
  }
  if (destination.includes("YO30 6LH")) {
    return "/products/book-your-blood-test-york";
  }
  if (destination.includes("G3 6LF")) {
    return "/products/book-your-blood-test-glasgow";
  }
  if (destination.includes("LE1 7GE")) {
    return "/products/book-your-blood-test-leicester";
  }
}

function generateDestinationTitle(destination) {
  if (destination.includes("EC2M 4TP")) {
    return "London City";
  }
  if (destination.includes("CR0 1SL")) {
    return "Croydon";
  }
  if (destination.includes("BN3 3AA")) {
    return "Brighton and Hove";
  }
  if (destination.includes("TN1 1NU")) {
    return "Royal Tunbridge Wells";
  }
  if (destination.includes("RH11 9AQ")) {
    return "Crawley";
  }
  if (destination.includes("GU1 3UQ")) {
    return "Guildford";
  }
  if (destination.includes("E14 9YX")) {
    return "London Canary Wharf";
  }
  if (destination.includes("SW1P 2QA")) {
    return "London Victoria";
  }
  if (destination.includes("CB2 1NS")) {
    return "Cambridge";
  }
  if (destination.includes("ME14 1HG")) {
    return "Maidstone";
  }
  if (destination.includes("EX4 3SR")) {
    return "Exeter";
  }
  if (destination.includes("PL1 1QJ")) {
    return "Plymouth";
  }
  if (destination.includes("W4 4JE")) {
    return "Chiswick";
  }
  if (destination.includes("L1 9AR")) {
    return "Liverpool";
  }
  if (destination.includes("CM1 1EH")) {
    return "Chelmsford";
  }
  if (destination.includes("BS8 4HR")) {
    return "Bristol";
  }
  if (destination.includes("GL50 4DT")) {
    return "Cheltenham";
  }
  if (destination.includes("B16 8LU")) {
    return "Birmingham";
  }
  if (destination.includes("OX2 6HA")) {
    return "Oxford";
  }
  if (destination.includes("MK9 2PQ")) {
    return "Milton Keynes";
  }
  if (destination.includes("M3 2RE")) {
    return "Manchester";
  }
  if (destination.includes("LS1 2PQ")) {
    return "Leeds";
  }
  if (destination.includes("CF24 1DH")) {
    return "Cardiff";
  }
  if (destination.includes("EH1 3QH")) {
    return "Edinburgh";
  }
  if (destination.includes("YO30 6LH")) {
    return "York";
  }
  if (destination.includes("G3 6LF")) {
    return "Glasgow";
  }
  if (destination.includes("LE1 7GE")) {
    return "Leicester";
  }
  if (destination.includes("NG1 1HN")) {
    return "Nottingham";
  }  
}

function generateLocationHtml(
  url,
  title,
  distance,
  duration,
  destination,
  no_button,
) {
  if (!no_button) {
    html =
      "<div style='border: 1px solid lightgrey; padding: 2px; padding-left: 10px;' onclick='window.location=\"" +
      url +
      "\"'>";
  } else {
    html =
      "<div style='border: 1px solid lightgrey; padding: 2px; padding-left: 10px;'>";
  }
  html +=
    '<strong style="text-transform: uppercase;">' +
    title +
    '</strong> - <i class="fa-solid fa-circle-check" style="color: #01b750;"></i><br />';
  html += "<div>";
  html +=
    "<small>" +
    "<i style=\"color: #EE2F35;\"class='fa-regular fa-car'></i> - " +
    (distance / 1852).toFixed(2) +
    " miles away. " +
    "<i style=\"color: #EE2F35;\"class='fa-regular fa-timer'></i> - " +
    duration;
  html += ".<br/>";
  html += "" + destination;
  html += "</small>";
  if (!no_button) {
    html += "<br />";
    html +=
      "<button style='font-size: 70%;' type='button' onclick='window.location=\"" +
      url +
      "\"' class='button-primary mdc-ripple-surface mdc-ripple-upgraded'>BOOK THIS CLINIC</button>";
  } else {
    html += "<br>BOOK YOUR SLOT ONLINE ON THE NEXT PAGE.";
  }
  html += "</div>";
  html += "</div>";
  return html;
}

// NEW MAPS
const clinics = [
  {
    name: "CANARY WHARF",
    address: "One Day Tests - Canary Wharf, 56 Dockyard Lane, London, E14 9YX",
    url: "https://onedaytests.com/products/book-your-blood-test-canary-wharf",
    lat: 51.499675,
    lon: -0.019847,
  },
  {
    name: "CHISWICK",
    address: "One Day Tests, 2 Heathfield Terrace, Chiswick, London W4 4JE, UK",
    url: "https://onedaytests.com/products/book-your-blood-test-chiswick",
    lat: 51.491422,
    lon: -0.26571,
  },
  {
    name: "CROYDON",
    address:
      "One Day Tests - The Wellness Therapy Centre, 3 Overton Yard, Croydon CR0 1SL",
    url: "https://onedaytests.com/products/book-your-blood-test-croydon",
    lat: 51.372803,
    lon: -0.101901,
  },
  {
    name: "LONDON CITY",
    address: "One Day Tests - 8-9 New Street, London EC2M 4TP",
    url: "https://onedaytests.com/products/book-your-blood-test-london-city",
    lat: 51.517221,
    lon: -0.079697,
  },
  {
    name: "LONDON VICTORIA",
    address: "One Day Tests - 10a Rochester Row, London, SW1P 2QA",
    url: "https://onedaytests.com/products/book-your-blood-test-london-victoria",
    lat: 51.495589,
    lon: -0.135602,
  },
  {
    name: "BIRMINGHAM",
    address: "One Day Tests, 86 Hagley Rd, Edgbaston, B16 8LU",
    url: "https://onedaytests.com/products/book-your-blood-test-birmingham",
    lat: 52.471564,
    lon: -1.92866,
  },
  {
    name: "HOVE",
    address: "One Day Tests - Hove, 39b Salisbury Road, Hove, BN3 3AA",
    url: "https://onedaytests.com/products/book-your-blood-test-hove",
    lat: 50.828223,
    lon: -0.163865,
  },
  {
    name: "BRISTOL",
    address: "One Day Tests - 27a Regent Street, Clifton, Bristol BS8 4HR",
    url: "https://onedaytests.com/products/book-your-blood-test-bristol",
    lat: 51.454384,
    lon: -2.618737,
  },
  {
    name: "CAMBRIDGE",
    address: "One Day Tests - 92 Chesterton Road, Cambridge, CB4 1ER",
    url: "https://onedaytests.com/products/book-your-blood-test-cambridge",
    lat: 52.215039,
    lon: 0.129186,
  },
  {
    name: "CHELMSFORD",
    address:
      "One Day Tests - Tindal House, Tindal Square, Chelmsford, Essex, CM1 1EH",
    url: "https://onedaytests.com/products/book-your-blood-test-chelmsford",
    lat: 51.734597,
    lon: 0.472099,
  },
  {
    name: "CHELTENHAM",
    address:
      "One Day Tests - 1 St Margaret’s Terrace, St Margaret’s Road, Cheltenham GL50 4DT",
    url: "https://onedaytests.com/products/book-your-blood-test-cheltenham",
    lat: 51.902943,
    lon: -2.073736,
  },
  {
    name: "CRAWLEY",
    address: "One Day Tests - Crawley, Coachmans Drive, RH11 9AQ",
    url: "https://onedaytests.com/products/book-your-blood-test-crawley",
    lat: 51.097484,
    lon: -0.202768,
  },
  {
    name: "EXETER",
    address: "The Exeter Business Hub, 46-48 Queen Street, Exeter, EX4 3SR",
    url: "https://onedaytests.com/products/book-your-blood-test-exeter",
    lat: 50.727334,
    lon: -3.535375,
  },
  {
    name: "GUILDFORD",
    address: "One Day Tests - 36-37 Castle Street, Guildford, GU1 3UQ",
    url: "https://onedaytests.com/products/book-your-blood-test-guildford",
    lat: 51.234283,
    lon: -0.573511,
  },
  {
    name: "LIVERPOOL",
    address: "One Day Tests - 88 Rodney Street, Liverpool, L1 9AR",
    url: "https://onedaytests.com/products/book-your-blood-test-liverpool",
    lat: 53.401889,
    lon: -2.973259,
  },
  {
    name: "MAIDSTONE",
    address: "One Day Tests - 39-48 Marsham Street, Maidstone, Kent ME14 1HH",
    url: "https://onedaytests.com/products/book-your-blood-test-maidstone",
    lat: 51.274505,
    lon: 0.527199,
  },
  {
    name: "MILTON KEYNES",
    address:
      "One Day Tests - Fortuna House, 651 S Fifth St, Milton Keynes MK9 2PQ",
    url: "https://onedaytests.com/products/book-your-blood-test-milton-keynes",
    lat: 52.036538,
    lon: -0.760357,
  },
  {
    name: "OXFORD",
    address: "One Day Tests - 3 Woodstock Road, Oxford, OX2 6HA",
    url: "https://onedaytests.com/products/book-your-blood-test-oxford",
    lat: 51.758949,
    lon: -1.26115,
  },
  {
    name: "PLYMOUTH",
    address:
      "One Day Tests - Eden Clinic, 23 Mayflower Street, Plymouth, PL1 1QJ",
    url: "https://onedaytests.com/products/book-your-blood-test-plymouth",
    lat: 50.373253,
    lon: -4.140941,
  },
  {
    name: "TUNBRIDGE WELLS",
    address:
      "One Day Tests, Prospect House, 11-13 Lonsdale Gardens, Royal Tunbridge Wells, TN1 1NU",
    url: "https://onedaytests.com/products/book-your-blood-test-tunbridge-wells",
    lat: 51.131066,
    lon: 0.26227,
  },
  {
    name: "CARDIFF",
    address: "One Day Tests, 128 Newport Road, Cardiff, CF24 1DH",
    url: "https://onedaytests.com/products/book-your-blood-test-cardiff",
    lat: 51.48862,
    lon: -3.15796,
  },
  {
    name: "LEEDS",
    address: "One Day Tests, 28 Park Road West, Leeds, LS1 2PQ",
    url: "https://onedaytests.com/products/book-your-blood-test-leeds",
    lat: 53.79909,
    lon: -1.55302,
  },
  {
    name: "MANCHESTER",
    address: "One Day Tests, 87 Bridge Street, Manchester, M3 2RE",
    url: "https://onedaytests.com/products/book-your-blood-test-manchester",
    lat: 53.481,
    lon: -2.2493,
  },
  {
    name: "NEWCASTLE",
    address: "One Day Tests, 14 Blandford Square, Newcastle upon Tyne, NE1 4HZ",
    url: "https://onedaytests.com/products/book-your-blood-test-newcastle",
    lat: 54.97011,
    lon: -1.6237,
  },
  {
    name: "SOUTHAMPTON",
    address: "One Day Tests, 2-4 Canute Road, Southampton, SO14 3FH",
    url: "https://onedaytests.com/products/book-your-blood-test-southampton",
    lat: 50.89746,
    lon: -1.394618,
  },
  {
    name: "EDINBURGH",
    address:
      "One Day Tests - Albany Street Clinic, 36a Albany Street, Edinburgh, EH1 3QH",
    url: "https://onedaytests.com/products/book-your-blood-test-edinburgh",
    lat: 55.95754,
    lon: -3.191148,
  },
  {
    name: "YORK",
    address: "One Day Tests - 11 Clifton Green, York, YO30 6LH",
    url: "https://onedaytests.com/products/book-your-blood-test-york",
    lat: 53.9694609,
    lon: -1.097622,
  },
  {
    name: "GLASGOW",
    address: "One Day Tests - 140 Woodlands Road, Glasgow, G3 6LF",
    url: "https://onedaytests.com/products/book-your-blood-test-glasgow",
    lat: 55.8698,
    lon: -4.274461,
  },
  {
    name: "LEICESTER",
    address:
      "One Day Tests - Room 2 - 9 De Montfort Street, Leicester, LE1 7GE",
    url: "https://onedaytests.com/products/book-your-blood-test-leicester",
    lat: 52.6293,
    lon: -1.123991,
  },
  {
    name: "LONDON - SOUTH KENSINGTON",
    address: "One Day Tests - 24 Stanhope Mews West, London, SW7 5RB",
    url: "https://onedaytests.com/products/book-your-blood-test-south-kensington",
    lat: 51.49499,
    lon: -0.182442,
  },
  {
    name: "READING",
    address: "One Day Tests - 61 Castle Street, Reading, RG1 7SN",
    url: "https://onedaytests.com/products/book-your-blood-test-reading",
    lat: 51.452367,
    lon: -0.976857,
  },
  {
    name: "CANTERBURY",
    address:
      "One Day Tests, Room 204 , Lombard House, 12/17 Upper Bridge Street, Canterbury, CT1 2NF",
    url: "https://onedaytests.com/products/book-your-blood-test-canterbury",
    lat: 51.276011,
    lon: 1.0827878,
  },
  {
    name: "LONDON COCKFOSTERS",
    address:
      "One Day Tests, 26 Heddon Court Parade, Cockfosters, Barnet, EN4 0DB",
    url: "https://onedaytests.com/products/book-your-blood-test-cockfosters",
    lat: 51.647797,
    lon: -0.150155,
  },
  {
    name: "NOTTINGHAM",
    address:
      "One Day Tests, Ground Floor, Unit 2, 12 High Pavement, Nottingham, NG1 1HN",
    url: "https://onedaytests.com/products/book-your-blood-test-nottingham",
    lat: 52.9509374,
    lon: -1.14497996,
  },
];

// To add to the clinic search page only
let showAllClinics = false;

async function handleInputInputEvent(
  event,
  isProductPage,
  isHomeKitWithAppointment = false,
) {
  await delay(200);
  const textInput = document.querySelector("#postcode1").value;

  await renderNearestClinics(
    textInput,
    isProductPage,
    isHomeKitWithAppointment,
  );
}

async function renderNearestClinics(
  inputText,
  isProductPage,
  isHomeKitWithAppointment,
) {
  const resultsList = document.getElementById("results");

  if (inputText === "") {
    const resultParagraph = document.createElement("p");
    resultParagraph.innerHTML =
      "<small>Please enter your postcode or location.</small>";
    resultsList.appendChild(resultParagraph);

    return;
  }

  const response = await fetch("https://maps.sussexpathology.com/matrix", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      address: inputText,
      clinics: clinics,
    }),
  });
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  const data = await response.json();

  resultsList.innerHTML = ""; // reset the results
  let sortedClinicWithDistances = data.distances;
  if (isProductPage) {
    sortedClinicWithDistances.length = 3;
  }

  let n = 3;
  for (const clinic of sortedClinicWithDistances) {
    const resultParagraph = document.createElement("p");
    resultParagraph.classList.add("result-paragraph");
    if (!showAllClinics && n <= 0) {
      resultParagraph.style.display = "none";
    }
    resultParagraph.innerHTML = generateClinicHtml(
      clinic,
      isProductPage,
      isHomeKitWithAppointment,
    );
    resultsList.appendChild(resultParagraph);
    n--;
  }

  const hasClinics = sortedClinicWithDistances.length > 0;
  if (!showAllClinics && hasClinics && !isProductPage) {
    const showMoreButton = createShowMoreClinicsButton();
    resultsList.appendChild(showMoreButton);
  }
}

function showBiomarkersGroupMenuItem(element, has_warning) {
  element.classList.replace("is-hidden", "is-shown");

  if (has_warning && !element.classList.contains("has-warning")) {
    element.classList.add("has-warning");
  }
}

function generateClinicHtml(clinic, isProductPage, isHomeKitWithAppointment) {
  const {
    distance,
    clinic: { name, address, url },
  } = clinic;

  var extraText = "";
  if (isProductPage && !isHomeKitWithAppointment) {
    extraText = "<strong>BOOK YOUR SLOT ONLINE, ON THE NEXT PAGE.</strong>";
  } else if (isHomeKitWithAppointment) {
    extraText =
      "<strong>SAME OR NEXT DAY AVAILABILITY, ONCE YOUR KIT ARRIVES.</strong>";
  } else {
    extraText =
      "<a style='font-size: 70%; color: white;' href='" +
      url +
      "' class='button-primary mdc-ripple-surface mdc-ripple-upgraded'>BOOK THIS CLINIC</a>";
  }

  return `
    <div style='border: 1px solid lightgrey; padding: 12px 2px; padding-left: 10px; background: white'>
      <strong style="text-transform: uppercase;">${name}</strong> - <i class="fa-solid fa-circle-check" style="color: #01b750;"></i>
      <br />
      <div>
        <small><i style="color: #EE2F35;" class="fa-regular fa-car"></i> - ${distance} miles away.
        <br />
        ${address}
        </small>
      </div>
      ${extraText}
    </div>
  `;
}

function createShowMoreClinicsButton() {
  const moreLink = document.createElement("button");

  // Reset button styling
  moreLink.style.background = "none";
  moreLink.style.border = "none";
  moreLink.style.padding = "0";
  moreLink.style.margin = "0";
  moreLink.style.cursor = "pointer";

  moreLink.textContent = "Show more clinics";

  moreLink.addEventListener("click", () => {
    showAllClinics = true;
    const hiddenClinicsResults = document.querySelectorAll(".result-paragraph");
    for (const result of hiddenClinicsResults) {
      result.style.display = "block";
    }
    moreLink.style.display = "none";
  });

  return moreLink;
}

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function calculateBMI() {
  let bmiChart;

  const ctx = document.getElementById("bmiChart").getContext("2d");
  bmiChart = new Chart(ctx, {
    type: "bar",
    data: {
      labels: ["Your BMI"],
      datasets: [
        {
          label: "BMI",
          data: [0],
          backgroundColor: "#ccc",
        },
      ],
    },
    options: {
      scales: {
        y: {
          beginAtZero: true,
          max: 40,
          title: {
            display: true,
            text: "BMI Value",
          },
        },
      },
    },
  });

  // 2) Hook up the form submission
  const bmiForm = document.querySelector(".bmi-form");
  bmiForm.addEventListener("submit", function (event) {
    event.preventDefault();
    calculateBMI(bmiChart);
  });

  const weightInput = document.getElementById("weight");
  const heightInput = document.getElementById("height");
  const resultDiv = document.getElementById("result");

  const weight = parseFloat(weightInput.value);
  const height = parseFloat(heightInput.value);

  if (isNaN(weight) || isNaN(height) || weight <= 0 || height <= 0) {
    resultDiv.textContent = "Please enter valid, positive values.";
    return;
  }

  // Convert cm to m
  const heightInMeters = height / 100;
  const bmi = weight / (heightInMeters * heightInMeters);
  const roundedBmi = bmi.toFixed(2);

  // Determine category and color
  let category = "";
  let color = "#ccc";

  if (bmi < 18.5) {
    category = "Underweight";
    color = "#3498db";
  } else if (bmi >= 18.5 && bmi <= 24.9) {
    category = "Normal weight";
    color = "#2ecc71";
  } else if (bmi >= 25 && bmi <= 29.9) {
    category = "Overweight";
    color = "#f1c40f";
  } else {
    category = "Obesity";
    color = "#e74c3c";
  }

  // Display BMI + category
  resultDiv.textContent = `Your BMI is ${roundedBmi} (${category}).`;

  // Update the chart
  bmiChart.data.datasets[0].data[0] = roundedBmi;
  bmiChart.data.datasets[0].backgroundColor = color;
  bmiChart.update();
  bmiChart.destroy();
}

function render_bmi_results(weight_test_results) {
  // Define helper functions
  function showNoResultsText() {
    document.getElementById("bmi_no_results_text").innerHTML =
      'You do not have any vitals available at this time. <a href="https://onedaytests.com/products/book-your-free-weight-loss-assessment-and-blood-test">Click here to get your free Weight Loss assessment!</a>';
    $("#loading_spinner_bmi").hide();
  }

  function formatValue(value) {
    if (value === undefined || value === null || value === "") return "N/A";

    const num = Number(value);
    if (isNaN(num)) return value; // not numeric, return as-is

    // Truncate to max 2 decimal places, remove trailing zeros
    return parseFloat(num.toFixed(2));
  }

  function renderRowData(resultObj) {
    return tableHeaders
      .slice(1) // skip 'Date'
      .map((header) => {
        const value = resultObj[header.dataKey];
        return `<td>${formatValue(value)}</td>`;
      })
      .join("");
  }

  function renderRow(res) {
    const renderedRowData = renderRowData(res);
    return `
      <tr>
        <td>${res.date}</td>
        ${renderedRowData}
      </tr>
    `;
  }

  if (!weight_test_results) {
    showNoResultsText();
    return;
  }

  // Correct common name spelling issues first
  const corrected_results_json = weight_test_results.map((result) => {
    if (result.name === "Systonic pressure") {
      return { ...result, name: "Systolic pressure" };
    }
    if (result.name === "Diastonic pressure") {
      return { ...result, name: "Diastolic pressure" };
    }
    if (result.name === "Height(cm)") {
      return { ...result, name: "Height (cm)" };
    }
    if (result.name === "Waist (CM)") {
      return { ...result, name: "Waist (cm)" };
    }
    return result;
  });

  // Define desired table headers and mapping
  const tableHeaders = [
    { text: "Date", dataKey: "date" },
    { text: "Systolic pressure", dataKey: "Systolic pressure" },
    { text: "Diastolic pressure", dataKey: "Diastolic pressure" },
    { text: "Height (cm)", dataKey: "Height (cm)" },
    { text: "Waist (cm)", dataKey: "Waist (cm)" },
    { text: "Weight (kg)", dataKey: "Weight (kg)" },
    { text: "BMI", dataKey: "BMI" },
  ];

  // The new structure requires merging results by date
  const mergedByDate = {};

  // Flatten results into date-based object
  for (const measurement of corrected_results_json) {
    for (const entry of measurement.result_list) {
      const date = entry.timestamp;
      if (!mergedByDate[date]) mergedByDate[date] = { date };
      mergedByDate[date][measurement.name] = entry.value;
    }
  }

  // Convert merged data back into an array for rendering
  const bmiResults = Object.values(mergedByDate);
  const tableHeaderHtml = tableHeaders
    .map((header) => `<th>${header.text}</th>`)
    .join("");

  const tableHtml = `
    <table class="account-table">
      <thead>
        <tr>
          ${tableHeaderHtml}
        </tr>
      </thead>
      <tbody>
        ${bmiResults.map(renderRow).join("")}
      </tbody>
    </table>
  `;

  document.querySelector("#bmi_table").innerHTML = tableHtml;
  $("#loading_spinner_bmi").hide();
}

function render_panel_list(panel_name_list) {
  const gridEl = document.getElementById("panelsGrid");
  let content = "";
  for (const panel_name of panel_name_list) {
    const panel = PANELS.find((p) => p.name == panel_name);
    if (!isEmpty(panel)) {
      content += getTestPanelTemplate(panel);
    }
  }

  gridEl.innerHTML += content;
}

function render_reports(report_list) {
  let htmlTable = `
    <table class="account-table account-order-list">
      <thead>
        <tr>
          <th>Date</th>
          <th>Results</th>
        </tr>
      </thead>
      <tbody>
  `;

  for (const [report_id, date] of Object.entries(report_list)) {
    htmlTable += `
      <tr>
        <td>${date}</td>
        <td>
          <a href="https://onedaytests.com/apps/report/${report_id}/"
             target="_blank" rel="noopener noreferrer">
             Results file
          </a>
        </td>
      </tr>
    `;
  }

  htmlTable += `
      </tbody>
    </table>
  `;

  document.getElementById("reports_table").innerHTML = htmlTable;
  $("#loading_spinner_lab").hide();

  // Combine pdf button
  const combine_pdf_button = document.querySelector("#combine-pdf-button");
  combine_pdf_button.style.display = "block";
  combine_pdf_button.addEventListener("click", () => {
    fetch("https://onedaytests.com/apps/report/")
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "generated.pdf";
        a.click();
      });
  });
}

function render_cards(results) {
  const graph_ids_test_results_maps_to_render = {};
  const categories_to_show_in_menu = new Map(); // Maps "category_name": has_warning
  let html = "";

  for (const category_map of results.category_list) {
    const category_name_title_case = category_map.category
      .toLowerCase()
      .split(" ")
      .filter(Boolean) // remove extra spaces
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    const category_name_camel_case = category_name_title_case.replace(
      /\s+/g,
      "",
    );
    categories_to_show_in_menu.set(category_name_camel_case, false);

    // We need two containers: one for graph view, one for table view
    let graphViewContent = "";
    let tableViewContent = "";

    // Loop through all biomarkers and render html
    for (const biomarker_map of category_map.biomarker_list) {
      for (const unit_map of biomarker_map.results_per_unit_list) {
        const title = biomarker_map.name + " (" + unit_map.units + ")";
        const id = toSafeId(title);

        // Is this a graph or a table?
        // We only show a graph if every test_result has a parseable "value_text".
        let is_graph = true;
        for (const test_result of unit_map.test_result_list) {
          const value = parseFloat(test_result.value_text);
          if (isNaN(value)) {
            is_graph = false;
            break;
          }
        }
        // Check if we should show a warning.
        // Given that we only show warnings if the result is above
        // or below ref ranges, we will only ever have a warning if it a
        // graph as graphs are rendered when "value_text" is parsable.
        // Only show warning if the limit is actually defined (not null)
        // and only for the LATEST result (sorted by date)
        let has_warning = false;
        const parseTimestamp = (dateStr) => {
          const [day, month, year] = dateStr.split("-");
          return new Date(year, month - 1, day);
        };
        const sortedResults = [...unit_map.test_result_list].sort(
          (a, b) => parseTimestamp(b.timestamp) - parseTimestamp(a.timestamp),
        );
        const test_result_most_recent = sortedResults[0];
        const upper = test_result_most_recent.upper_limit;
        const lower = test_result_most_recent.lower_limit;
        const value = test_result_most_recent.value;
        const is_too_high = upper !== null && value > upper;
        const is_too_low = lower !== null && value < lower;
        if (is_too_high || is_too_low) {
          has_warning = true;
        }

        // Always render a table card for the table view
        const tableCard = render_table_card(
          id + "-table",
          title,
          unit_map.units,
          unit_map.test_result_list,
          biomarker_map.description,
          biomarker_map.low_description,
          biomarker_map.high_description,
          has_warning,
        );
        tableViewContent += tableCard;

        // For graph view: render graph if possible, otherwise render table
        if (is_graph) {
          if (has_warning) {
            categories_to_show_in_menu.set(category_name_camel_case, true);
          }

          graph_ids_test_results_maps_to_render[id] = {
            title: title,
            test_results: unit_map.test_result_list,
            has_warning: has_warning,
            category_id: category_name_camel_case,
          };
          graphViewContent += render_graph_card(
            id,
            biomarker_map.description,
            biomarker_map.low_description,
            biomarker_map.high_description,
          );
        } else {
          // Non-graphable biomarkers show as tables in both views
          graphViewContent += render_table_card(
            id,
            title,
            unit_map.units,
            unit_map.test_result_list,
            biomarker_map.description,
            biomarker_map.low_description,
            biomarker_map.high_description,
            has_warning,
          );
        }
      }
    }

    // Build category section with both graph and table containers
    const category_section = `
      <div id="${category_name_camel_case}">
        <h4 class="color-text-400">${category_name_title_case}</h4>
        <div class="biomarkers-grid is-shown">
          ${graphViewContent}
        </div>
        <div class="biomarkers-table-grid is-hidden">
          ${tableViewContent}
        </div>
      </div>
    `;
    html += category_section;
  }

  // Add Alex section
  html += `
    <div id="alex" style="display: none;">
      <h4 class="color-text-400">ALEX Allergy Screening</h4>
      <div class="biomarkers-grid">
        <div class="biomarker-card" style="display: inline-block;">
          <div class="biomarker_chart_container" id="Alex panel">
            <img
              src="https://onedaytests.com/cdn/shop/t/126/assets/alexlogo.webp?v=35151082142724928121762787297"
              alt="Description of the image"
              style="width: auto; height: auto; max-width: 100%; max-height: 100%; display: block; margin: 0 auto;"
            >
          </div>
          <div class="biomarker-description-tabs">
            <div class="odt-tabs" id="biomarkeralexTabs" role="tablist">
              <div
                class="tab-item"
                role="tab"
                id="description-alex-tab"
                aria-controls="description-alex"
                aria-selected="true"
              >
                Description
              </div>
            </div>

            <div class="tab-container" id="biomarkeralexContainer">
              <div
                class="tab-content"
                id="description-alex"
                role="tabpanel"
                aria-labelledby="description-alex-tab"
              >
                <p>
                  The Alex Allergy screen is a separate and complex investigation, so you will find your results
                  in a separate report that is emailed to you.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {% comment %} Check if the customer has ordered ALEX {% endcomment %}
      {% assign product_id_to_check = '8139540398300' %}
      {% assign has_purchased_alex = false %}
      {% for order in customer.orders %}
        {% for line_item in order.line_items %}
          {% if line_item.product_id == product_id_to_check %}
            <script>
              document.querySelector('#alex').style.display = 'block';
            </script>
          {% endif %}
        {% endfor %}
      {% endfor %}
    </div>
    `;

  // Add all rendered html to grid
  document.querySelector("#graphGrid").innerHTML = html;

  // Loop through all graphs and set them up.
  // We also check if there is an out of range res
  for (const [
    id,
    {
      test_results: test_results,
      title: title,
      has_warning: has_warning,
      category_id: category_id,
    },
  ] of Object.entries(graph_ids_test_results_maps_to_render)) {
    render_graph(id, title, test_results, has_warning, category_id);
  }

  // Initialize all tabs in the biomarker cards
  document
    .querySelectorAll(".biomarker-description-tabs")
    .forEach((tabsContainer) => {
      const tabContainer = tabsContainer.querySelector(".tab-container");
      const tabsParent = tabsContainer.querySelector(".odt-tabs");
      if (tabContainer && tabsParent) {
        tabs(
          `#${tabContainer.id} > .tab-content`,
          `#${tabsParent.id}`,
          ".tab-item",
          "is-active",
        );
      }
    });

  // loop through all categories to show in the menu
  for (const [category_name, has_warning] of categories_to_show_in_menu) {
    const element = document.querySelector(
      `.panel-grid-item[href='#${category_name}']`,
    );
    showBiomarkersGroupMenuItem(element, has_warning);
  }
}

function render_graph(id, title, test_result_list, has_warning) {
  // Check if any reference ranges exist (both upper AND lower must be null to have no range)
  const hasReferenceRanges = test_result_list.some(
    (tr) => tr.upper_limit !== null || tr.lower_limit !== null,
  );

  const mapped = test_result_list
    .map((test_result) => {
      const [day, month, year] = test_result.timestamp.split("-");
      const date = `${year}-${month}-${day}`;
      return {
        date: date,
        value: parseFloat(test_result.value_text),
        upper: test_result.upper_limit ?? 0,
        lower: test_result.lower_limit ?? 0,
      };
    })
    .sort((a, b) => new Date(a.date) - new Date(b.date));

  const dates = mapped.map((d) => d.date);
  const values = mapped.map((d) => d.value);
  const upperLimits = mapped.map((d) => d.upper);
  const lowerLimits = mapped.map((d) => d.lower);

  // Calculate y-axis minimum: max of (0, 10% below lower limit, 10% below lowest value)
  const minLowerLimit = hasReferenceRanges ? Math.min(...lowerLimits) : 0;
  const minValue = Math.min(...values);
  const tenPercentBelowLower = minLowerLimit - minLowerLimit * 0.1;
  const tenPercentBelowValue = minValue - minValue * 0.1;
  const yAxisMin = Math.max(
    0,
    Math.min(tenPercentBelowLower, tenPercentBelowValue),
  );

  // Calculate y-axis maximum: 10% above the max of (upper limit, highest value)
  const maxUpperLimit = hasReferenceRanges ? Math.max(...upperLimits) : 0;
  const maxValue = Math.max(...values);
  // Round to 2 decimal places to avoid floating point precision issues like "0000002"
  const yAxisMax =
    Math.round(Math.max(maxUpperLimit, maxValue) * 1.1 * 100) / 100;

  const chartContainer = document.getElementById(`${id}_graph_container`);
  if (!chartContainer) {
    console.error(`Container not found: ${id}_graph_container`);
    return;
  }

  const chart = echarts.init(chartContainer);

  const option = {
    backgroundColor: "#f8f8f8",
    title: {
      text: title,
      left: "center",
      top: 10,
      textStyle: {
        fontSize: 14,
        fontWeight: "normal",
      },
    },
    tooltip: {
      trigger: "axis",
      confine: true,
      textStyle: {
        fontSize: 12,
      },
      formatter: function (params) {
        const date = new Date(params[0].axisValue);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;
        const value = params.find((p) => p.seriesName === title)?.value ?? "";
        return `${formattedDate}<br/>${title}: ${value}`;
      },
    },
    legend: {
      show: false,
    },
    grid: {
      left: "10%",
      right: "10%",
      top: has_warning ? 80 : 60,
      bottom: "15%",
    },
    xAxis: {
      type: "category",
      data: dates,
      axisLabel: {
        formatter: function (value) {
          const date = new Date(value);
          return date.toLocaleDateString("en-GB", {
            year: "numeric",
            month: "short",
          });
        },
      },
    },
    yAxis: {
      type: "value",
      name: "",
      min: yAxisMin,
      max: yAxisMax,
    },
    series: [
      // Custom series for the range band and step lines (extends to chart edges)
      // Only render if there are actual reference ranges
      ...(hasReferenceRanges
        ? [
            {
              name: "Reference Range",
              type: "custom",
              renderItem: function (params, api) {
                if (params.dataIndex > 0) return; // Only render once

                // Get x coordinates for all data points
                const xCoords = [];
                for (let i = 0; i < dates.length; i++) {
                  xCoords.push(api.coord([i, 0])[0]);
                }

                // Get the chart grid boundaries using api.size and api.coord
                const gridWidth = api.size([1, 0])[0] * dates.length;
                const chartLeft = xCoords[0] - api.size([1, 0])[0] / 2;
                const chartRight =
                  xCoords[xCoords.length - 1] + api.size([1, 0])[0] / 2;

                // Calculate extension to edges
                const pointGap =
                  dates.length > 1
                    ? xCoords[1] - xCoords[0]
                    : chartRight - chartLeft;
                const extendLeft =
                  dates.length > 1 ? xCoords[0] - pointGap / 2 : chartLeft;
                const extendRight =
                  dates.length > 1
                    ? xCoords[xCoords.length - 1] + pointGap / 2
                    : chartRight;

                // Build segments: each segment is a rectangle from one boundary to the next
                // Boundaries are: extendLeft, midpoints between data points, extendRight
                const boundaries = [extendLeft];
                for (let i = 0; i < dates.length - 1; i++) {
                  boundaries.push((xCoords[i] + xCoords[i + 1]) / 2);
                }
                boundaries.push(extendRight);

                // Create rectangles and line segments
                const children = [];
                const upperLinePoints = [];
                const lowerLinePoints = [];

                for (let i = 0; i < dates.length; i++) {
                  const leftX = boundaries[i];
                  const rightX = boundaries[i + 1];
                  const upperY = api.coord([i, upperLimits[i]])[1];
                  const lowerY = api.coord([i, lowerLimits[i]])[1];

                  // Add filled rectangle for this segment
                  children.push({
                    type: "rect",
                    shape: {
                      x: leftX,
                      y: Math.min(upperY, lowerY),
                      width: rightX - leftX,
                      height: Math.abs(lowerY - upperY),
                    },
                    style: {
                      fill: "rgba(218, 235, 241, 0.7)",
                    },
                    z: 1,
                  });

                  // Build line points for upper and lower
                  if (i === 0) {
                    upperLinePoints.push([leftX, upperY]);
                    lowerLinePoints.push([leftX, lowerY]);
                  } else {
                    // Add step: vertical transition then horizontal
                    const prevUpperY = api.coord([
                      i - 1,
                      upperLimits[i - 1],
                    ])[1];
                    const prevLowerY = api.coord([
                      i - 1,
                      lowerLimits[i - 1],
                    ])[1];
                    upperLinePoints.push([leftX, prevUpperY]);
                    upperLinePoints.push([leftX, upperY]);
                    lowerLinePoints.push([leftX, prevLowerY]);
                    lowerLinePoints.push([leftX, lowerY]);
                  }
                  upperLinePoints.push([rightX, upperY]);
                  lowerLinePoints.push([rightX, lowerY]);
                }

                // Add upper limit dashed line - using individual line segments to avoid fill issues
                for (let j = 0; j < upperLinePoints.length - 1; j++) {
                  children.push({
                    type: "line",
                    shape: {
                      x1: upperLinePoints[j][0],
                      y1: upperLinePoints[j][1],
                      x2: upperLinePoints[j + 1][0],
                      y2: upperLinePoints[j + 1][1],
                    },
                    style: {
                      stroke: "#e40712",
                      lineWidth: 2,
                      lineDash: [6, 4],
                    },
                    z: 2,
                  });
                }

                // Add "High range" text label above upper limit line
                const firstUpperY = upperLinePoints[0][1];
                children.push({
                  type: "text",
                  style: {
                    text: "High range",
                    x: extendLeft + 5,
                    y: firstUpperY - 14,
                    fill: "#666",
                    fontSize: 11,
                    fontWeight: "normal",
                  },
                  z: 3,
                });

                // Add lower limit dashed line - using individual line segments to avoid fill issues
                for (let j = 0; j < lowerLinePoints.length - 1; j++) {
                  children.push({
                    type: "line",
                    shape: {
                      x1: lowerLinePoints[j][0],
                      y1: lowerLinePoints[j][1],
                      x2: lowerLinePoints[j + 1][0],
                      y2: lowerLinePoints[j + 1][1],
                    },
                    style: {
                      stroke: "#e40712",
                      lineWidth: 2,
                      lineDash: [6, 4],
                    },
                    z: 2,
                  });
                }

                // Add "Low range" text label above lower limit line
                const firstLowerY = lowerLinePoints[0][1];
                children.push({
                  type: "text",
                  style: {
                    text: "Low range",
                    x: extendLeft + 5,
                    y: firstLowerY - 14,
                    fill: "#666",
                    fontSize: 11,
                    fontWeight: "normal",
                  },
                  z: 3,
                });

                return {
                  type: "group",
                  children: children,
                };
              },
              data: [0], // Dummy data to trigger renderItem
              z: 1,
            },
          ]
        : []),
      // Main data line
      {
        name: title,
        type: "line",
        data: values,
        smooth: true,
        symbol: "circle",
        symbolSize: 8,
        lineStyle: {
          color: "#5470c6",
          width: 2,
        },
        itemStyle: {
          color: "#5470c6",
        },
        z: 10,
      },
    ],
    graphic: has_warning
      ? [
          {
            type: "group",
            right: 10,
            top: 40,
            children: [
              {
                type: "rect",
                shape: {
                  width: 130,
                  height: 24,
                  r: 12,
                },
                style: {
                  fill: "transparent",
                  stroke: "#F5973A",
                  lineWidth: 2,
                },
              },
              {
                type: "text",
                style: {
                  text: "Needs attention •",
                  x: 65,
                  y: 12,
                  textAlign: "center",
                  textVerticalAlign: "middle",
                  fill: "#F5973A",
                  fontSize: 12,
                },
              },
            ],
          },
        ]
      : [],
  };

  chart.setOption(option);

  // Handle resize
  window.addEventListener("resize", function () {
    chart.resize();
  });
}

/// Just renders the html, this does not load the graph.
function render_graph_card(id, general_desc, low_desc, high_desc) {
  return `
    <div class="biomarker-card">  
      <div class="biomarker_chart_container" id="${id}_graph_container"></div>
      <div>
        <i>
          <small>Shown reference ranges are general guidelines only. Ranges change over time and are not specific to you.
            Use laboratory PDF ranges in case of differences with your dashboard. Please consult your doctor for further interpretation, specific to you.
          </small>
        </i>
      </div>           
      ${(() => {
        const hasDesc = general_desc && general_desc !== "null";
        const hasLow = low_desc && low_desc !== "null";
        const hasHigh = high_desc && high_desc !== "null";
        if (!hasDesc && !hasLow && !hasHigh) return "";
        const tabs = [];
        const contents = [];
        let firstTab = true;
        if (hasDesc) {
          tabs.push(
            `<div class="tab-item${firstTab ? "" : " ml-auto"}" role="tab" id="description-${id}-tab" aria-controls="description-${id}" aria-selected="${firstTab}">Description</div>`,
          );
          contents.push(
            `<div class="tab-content" id="description-${id}" role="tabpanel" aria-labelledby="description-${id}-tab">${general_desc}</div>`,
          );
          firstTab = false;
        }
        if (hasLow) {
          tabs.push(
            `<div class="tab-item${firstTab ? "" : " ml-auto"}" role="tab" id="low-result-${id}-tab" aria-controls="low-result-${id}" aria-selected="${firstTab}">Low result</div>`,
          );
          contents.push(
            `<div class="tab-content" id="low-result-${id}" role="tabpanel" aria-labelledby="low-result-${id}-tab">${low_desc}</div>`,
          );
          firstTab = false;
        }
        if (hasHigh) {
          tabs.push(
            `<div class="tab-item${!hasLow && !firstTab ? " ml-auto" : ""}" role="tab" id="high-result-${id}-tab" aria-controls="high-result-${id}" aria-selected="${firstTab}">High result</div>`,
          );
          contents.push(
            `<div class="tab-content" id="high-result-${id}" role="tabpanel" aria-labelledby="high-result-${id}-tab">${high_desc}</div>`,
          );
        }
        return `
      <div class="biomarker-description-tabs">
        <div class="odt-tabs" id="biomarker${id}Tabs" role="tablist">
          ${tabs.join("\n          ")}
        </div>
        <div class="tab-container" id="biomarker${id}Container">
          ${contents.join("\n          ")}
        </div>
      </div>`;
      })()}
    </div>
  `;
}

function old_render_table_card(
  id,
  name,
  general_desc,
  low_desc,
  high_desc,
  test_result_list,
) {
  const table = get_table(test_result_list);
  return `
    <div class="biomarker-card">  
      <h5>${name}</h5>
      ${table}
      <div>
        <i>
          <small>Shown reference ranges are general guidelines only. Ranges change over time and are not specific to you.
            Use laboratory PDF ranges in case of differences with your dashboard. Please consult your doctor for further interpretation, specific to you.
          </small>
        </i>
      </div>           
      ${(() => {
        const hasDesc = general_desc && general_desc !== "null";
        const hasLow = low_desc && low_desc !== "null";
        const hasHigh = high_desc && high_desc !== "null";
        if (!hasDesc && !hasLow && !hasHigh) return "";
        const tabs = [];
        const contents = [];
        let firstTab = true;
        if (hasDesc) {
          tabs.push(
            `<div class="tab-item${firstTab ? "" : " ml-auto"}" role="tab" id="description-${id}-tab" aria-controls="description-${id}" aria-selected="${firstTab}">Description</div>`,
          );
          contents.push(
            `<div class="tab-content" id="description-${id}" role="tabpanel" aria-labelledby="description-${id}-tab">${general_desc}</div>`,
          );
          firstTab = false;
        }
        if (hasLow) {
          tabs.push(
            `<div class="tab-item${firstTab ? "" : " ml-auto"}" role="tab" id="low-result-${id}-tab" aria-controls="low-result-${id}" aria-selected="${firstTab}">Low result</div>`,
          );
          contents.push(
            `<div class="tab-content" id="low-result-${id}" role="tabpanel" aria-labelledby="low-result-${id}-tab">${low_desc}</div>`,
          );
          firstTab = false;
        }
        if (hasHigh) {
          tabs.push(
            `<div class="tab-item${!hasLow && !firstTab ? " ml-auto" : ""}" role="tab" id="high-result-${id}-tab" aria-controls="high-result-${id}" aria-selected="${firstTab}">High result</div>`,
          );
          contents.push(
            `<div class="tab-content" id="high-result-${id}" role="tabpanel" aria-labelledby="high-result-${id}-tab">${high_desc}</div>`,
          );
        }
        return `
      <div class="biomarker-description-tabs">
        <div class="odt-tabs" id="biomarker${id}Tabs" role="tablist">
          ${tabs.join("\n          ")}
        </div>
        <div class="tab-container" id="biomarker${id}Container">
          ${contents.join("\n          ")}
        </div>
      </div>`;
      })()}
    </div>
    <script>
      tabs('#biomarker${id}Container > .tab-content', '#biomarker${id}Tabs', '.tab-item', 'is-active');
    </script>
  `;
}

function get_table(test_result_list) {
  let html = `
      <table border="1">
        <tr>
          <th>Date</th>
          <th>Value</th>
          <th>Upper Limit</th>
          <th>Lower Limit</th>
        </tr>
    `;
  for (const test_result of test_result_list) {
    html += `
        <tr>
          <td>${test_result.timestamp}</td>
          <td>${test_result.value_text}</td>
          <td>${test_result.upper_limit}</td>
          <td>${test_result.lower_limit}</td>
        </tr>
      `;
  }
  html += `
      </table>
    `;
  return html;
}

function toSafeId(str) {
  return (
    str
      .trim() // remove extra spaces
      .toLowerCase()
      // convert common unit symbols to text before stripping
      .replace(/%/g, "percent")
      .replace(/\^/g, "pow")
      .replace(/\//g, "per")
      // replace spaces and invalid chars with dashes
      .replace(/[^a-z0-9\-_]+/g, "-")
      // collapse multiple dashes
      .replace(/-+/g, "-")
      // trim leading/trailing dashes
      .replace(/^-|-$/g, "")
  );
}

/**
 * Renders the panel page content: test groups list and main content area.
 * Used for individual panel pages (e.g., Ultimate Longevity Blood Test).
 * Sidebar icon and counts are rendered statically in Liquid template.
 * @param {Object} results - The results object from the API
 */
function render_panel_cards(results, showCategoryDescriptions = true) {
  const graph_ids_test_results_maps_to_render = {};

  // Build test groups list HTML
  let testGroupsHtml = "";
  for (const category_map of results.category_list) {
    const category_name_title_case = category_map.category
      .toLowerCase()
      .split(" ")
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
    const category_name_camel_case = category_name_title_case.replace(/\s+/g, "");

    testGroupsHtml += `
      <li class="aside-test-list-item">
        <a href="#${category_name_camel_case}Section">
          <i class="fa-solid fa-chevron-right aside-test-list-icon"></i>
          ${category_name_title_case}
        </a>
      </li>
    `;
  }

  // Build main content HTML
  let mainHtml = `
    <button onclick="printArea()" class="icon-button color-text-300 print-button">
      <i class="fa-solid fa-print"></i>
      Print
    </button>
  `;

  // Add panel header if panel_name exists
  if (results.panel_name) {
    mainHtml += `
    <div class="panel-page-header">
      <h2 class="panel-page-header-title">Understanding your "${results.panel_name}"</h2>
      ${results.description ? `<p>${results.description}</p>` : ""}
    </div>
    `;
  }

  // Build each category section
  for (const category_map of results.category_list) {
    const category_name_title_case = category_map.category
      .toLowerCase()
      .split(" ")
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
    const category_name_camel_case = category_name_title_case.replace(/\s+/g, "");
    const categoryId = `${category_name_camel_case}Section`;

    // Build biomarker cards for this category
    let biomarkerCardsHtml = "";
    for (const biomarker_map of category_map.biomarker_list) {
      for (const unit_map of biomarker_map.results_per_unit_list) {
        const title = biomarker_map.name + " (" + unit_map.units + ")";
        const id = toSafeId(title);

        // Is this a graph or a table?
        let is_graph = true;
        for (const test_result of unit_map.test_result_list) {
          const value = parseFloat(test_result.value_text);
          if (isNaN(value)) {
            is_graph = false;
            break;
          }
        }

        // Check for warnings on latest result
        let has_warning = false;
        const parseTimestamp = (dateStr) => {
          const [day, month, year] = dateStr.split("-");
          return new Date(year, month - 1, day);
        };
        const sortedResults = [...unit_map.test_result_list].sort(
          (a, b) => parseTimestamp(b.timestamp) - parseTimestamp(a.timestamp),
        );
        const test_result_most_recent = sortedResults[0];
        const upper = test_result_most_recent.upper_limit;
        const lower = test_result_most_recent.lower_limit;
        const value = test_result_most_recent.value;
        const is_too_high = upper !== null && value > upper;
        const is_too_low = lower !== null && value < lower;
        if (is_too_high || is_too_low) {
          has_warning = true;
        }

        if (is_graph) {
          graph_ids_test_results_maps_to_render[id] = {
            title: title,
            test_results: unit_map.test_result_list,
            has_warning: has_warning,
            category_id: category_name_camel_case,
          };
          biomarkerCardsHtml += render_graph_card(
            id,
            biomarker_map.description,
            biomarker_map.low_description,
            biomarker_map.high_description,
          );
        } else {
          biomarkerCardsHtml += render_table_card(
            id,
            title,
            unit_map.units,
            unit_map.test_result_list,
            biomarker_map.description,
            biomarker_map.low_description,
            biomarker_map.high_description,
            has_warning,
          );
        }
      }
    }

    // Build category tabs HTML
    const hasDoctorsComments = category_map.doctors_comments && category_map.doctors_comments !== "null";
    const hasOther = category_map.other && category_map.other !== "null";
    const tabsId = `${category_name_camel_case}Tabs`;
    const containerId = `${category_name_camel_case}Container`;

    let tabsHtml = `
      <div class="odt-tabs" id="${tabsId}" role="tablist">
        <div class="tab-item is-active" role="tab" aria-selected="true">Biomarkers</div>
        <div class="tab-item" role="tab" aria-selected="false">Doctor's comments</div>
        <div class="tab-item" role="tab" aria-selected="false">Other</div>
      </div>
    `;

    let tabContentsHtml = `
      <div class="tab-container" id="${containerId}">
        <div class="panel-page-tab-content" role="tabpanel">
          <div id="${category_name_camel_case}">
            <div class="panel-page-biomarkers-grid">
              ${biomarkerCardsHtml}
            </div>
            <div class="biomarkers-table-grid"></div>
          </div>
        </div>
        <div class="panel-page-tab-content" role="tabpanel">
          ${hasDoctorsComments ? category_map.doctors_comments : "<p>No doctor's comments available.</p>"}
        </div>
        <div class="panel-page-tab-content" role="tabpanel">
          ${hasOther ? category_map.other : "<h3>No further information.</h3>"}
        </div>
      </div>
    `;

    mainHtml += `
      <section>
        <article class="panel-page-article">
          <h4 class="panel-page-article-title" id="${categoryId}">${category_name_title_case}</h4>
          ${showCategoryDescriptions && category_map.description ? `<div class="panel-page-article-columns"><p>${category_map.description}</p></div>` : ""}
        </article>
        <div class="panel-page-biomarkers-grid-container">
          <div class="page-panel-biomarkers-tabs">
            ${tabsHtml}
            <div class="panel-page-biomarkers-grid-wrapper">
              ${tabContentsHtml}
            </div>
          </div>
        </div>
      </section>
    `;
  }

  // Insert HTML into DOM
  document.getElementById("testGroupsList").innerHTML = testGroupsHtml;
  document.getElementById("panelContent").innerHTML = mainHtml;

  // Render all graphs
  for (const [
    id,
    { test_results, title, has_warning, category_id },
  ] of Object.entries(graph_ids_test_results_maps_to_render)) {
    render_graph(id, title, test_results, has_warning, category_id);
  }

  // Initialize tabs for each category
  for (const category_map of results.category_list) {
    const category_name_title_case = category_map.category
      .toLowerCase()
      .split(" ")
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
    const category_name_camel_case = category_name_title_case.replace(/\s+/g, "");
    const tabsId = `${category_name_camel_case}Tabs`;
    const containerId = `${category_name_camel_case}Container`;

    tabs(
      `#${containerId} > .panel-page-tab-content`,
      `#${tabsId}`,
      ".tab-item",
      "is-active",
    );
  }

  // Initialize biomarker description tabs
  document.querySelectorAll(".biomarker-description-tabs").forEach((tabsContainer) => {
    const tabContainer = tabsContainer.querySelector(".tab-container");
    const tabsParent = tabsContainer.querySelector(".odt-tabs");
    if (tabContainer && tabsParent) {
      tabs(
        `#${tabContainer.id} > .tab-content`,
        `#${tabsParent.id}`,
        ".tab-item",
        "is-active",
      );
    }
  });

  // Initialize show more buttons
  toggleShowMoreButton();

  // Initialize sidebar toggle
  const buttonTestListToggle = document.getElementById("testListToggle");
  const testListCloseButton = document.getElementById("testListClose");
  if (buttonTestListToggle) {
    buttonTestListToggle.onclick = () => toggleTestListVisibility(buttonTestListToggle);
  }
  if (testListCloseButton) {
    testListCloseButton.onclick = () => toggleTestListVisibility(buttonTestListToggle);
  }

  // Initialize scroll to element for sidebar links
  onclickScrollToElement(".aside-test-list-item a");

  // Toggle biomarker view (graph/table)
  activatePanelsPageToggleBiomarkersView(".panel-page-biomarkers-grid-wrapper");
}
